export default "__VITE_ASSET__60fdbaa2__"